module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_5.3eeb9a17.png";